<template>
    <div class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm transition-opacity"></div>
        <div class="fixed inset-0 z-30 overflow-y-auto">
            <div class="flex min-h-full items-end px-4 pb-16 text-center max-w-lg mx-auto">
                <div class="border-2 border-jackpot-bg flex-1 relative transform overflow-hidden rounded-lg text-left drop-shadow-xl transition-all">
                    <div class="bg-white dark:bg-global-bg p-4">
                        <div class="text-center">
                            <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-gray-50">Change Name</h3>
                            <div class="mt-2">
                                <input v-model="name" :maxlength="max" type="text" class="block text-sm text-black w-full rounded border border-gray-400 p-2 outline-none focus-none sm:text-sm" :placeholder="`Max. Lenght: ${max} characters`" />
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 dark:bg-global-bg px-4 py-3 flex flex-col">
                        <button
                            @click.prevent="submit"
                            type="button"
                            class="modal-action-button"
                            :disabled="name.length < 3"
                        >Change Name</button>
                        <button
                            @click.prevent="close"
                            type="button"
                            class="modal-cancel-button"
                        >Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChangeNameModal',
    props: ['account', 'token'],
    data() {
        return {
            name: '',
            max: 12
        }
    },
    computed: {
        currentName() {
            return this.account ? this.account.name : ''
        }
    },
    mounted() {
        this.name = this.currentName
    },
    methods: {
        submit() {
            if (this.name.length < 3) {
                return
            }
            window.axios.post('/api/account/name', {
                'name': this.name
            }, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            })
            .then(() => {
                this.name = ''
                this.emitter.emit('close-modal', 'name_modal')
                this.$toast.success('Name changed')
            })
            .catch((err) => {
                if (err.response && err.response.status == 401) {
                    this.$toast.error('You need to login.')
                } else {
                    this.$toast.error(err.message)
                }
            })
        },
        close() {
            this.emitter.emit('close-modal', 'name_modal')
        }
    }
}
</script>
